import React from 'react';
import PageTitle from '../../components/PageTitle';

export default function index() {
  return <PageTitle />;
}
